import getLink from '../storage/get-link';
import clearStorage from '../storage/local/clear';
import clearCookie from '../storage/cookie/clear';
import fetchedLink from '../link/fetched';
import linkHasReachedFetchLimit from '../link/has-reached-fetch-limit';
import storeLink from '../storage/set-link';
import urlMatchMessage from '../message/url-match';
import urlIsMatch from '../url/is-match';
import postMessage from '../message/post';
import { ShareLinkMessengerMessage } from '../message/type/ShareLinkMessengerMessage';

type T = (message: ShareLinkMessengerMessage) => void;

const f: T = (message) => {
    const { url } = message.payload;
    const storedLink = getLink();

    if (!storedLink) return;

    if (urlIsMatch(url as string, storedLink.url)) {
        postMessage(window.parent, urlMatchMessage(storedLink.id));
        clearStorage();
        clearCookie('share-link');

        return;
    }

    const link = fetchedLink(storedLink);

    if (linkHasReachedFetchLimit(link)) {
        clearStorage();
        clearCookie('share-link');

        return;
    }

    storeLink(link);
};

export default f;
